<template>
	<div class="announcement">
		<div class="ma-4">
			<h2>{{ $t("announcement.header") }}</h2>
			<v-expansion-panels class="my-3" v-model="panel_system">
				<v-expansion-panel>
					<v-expansion-panel-header color="green lighten-5">
						<h5>{{ $t("announcement.expansion.system_header") }}</h5>
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<v-list three-line>
							<template v-for="(item, index) in system_announcements">
								<v-list-item :key="index+5">
									<v-tooltip top round :color="priority[item.priority]">
										<template v-slot:activator="{ on, attrs }">
											<span v-bind="attrs" v-on="on">
												<v-badge class="mr-3" :color="priority[item.priority]" inline dot></v-badge>
											</span>
										</template>
										<span v-if="$i18n.locale=='tc'">{{ priority_name_chi[item.priority] }}</span>
										<span v-else>{{ priority_name[item.priority] }}</span>
									</v-tooltip>
									<!--v-badge class="mr-3" :color="priority[item.priority]" inline left dot></v-badge-->
									<v-list-item-content v-if="$i18n.locale=='tc'">
										<v-list-item-subtitle class="mb-2">建立：{{item.create_at | moment("YYYY-MM-DD") }} （更新：{{ item.update_at | moment("YYYY-MM-DD") }}）</v-list-item-subtitle>
										{{ item.value_ch }}
									</v-list-item-content>
									<v-list-item-content v-else>
										<v-list-item-subtitle class="mb-2">Created at: {{item.create_at | moment("YYYY-MM-DD") }} (Updated at: {{ item.update_at | moment("YYYY-MM-DD") }})</v-list-item-subtitle>
										{{ item.value_en }}
									</v-list-item-content>
								</v-list-item>
								<v-divider :key="index" :inset="inset" class="m-0"></v-divider>
							</template>
						</v-list>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>
		</div>
	</div>
</template>
<script>

import moment from "moment";
import {api_dds_general} from '@/services/dds/api_dds_general';
const apiDDSGeneral = new api_dds_general(process.env.VUE_APP_BASE_URL);


export default {
	name: 'about',
	components: {
	},
	data:function(){
		return{
			current:{
				school_code: null,
				username: null,
				uid: null,
				user_level: "STUDENT",
				auth_token: null,
			},
			inset: true,
			panel_system: 0,			
			panel_school: 0,
			priority: [null, 'light-green lighten-2', 'amber accent-2', 'orange accent-3', 'red darken-3'] ,
			priority_name: [null, 'Low', 'Normal', 'Important', 'Crucial'],
			priority_name_chi: [null, '不重要', '一般', '重要', '非常重要'],
			logo:require('@/assets/remotelab-logo-small.png'),
			system_announcements: [],
			school_announcements: [],
		}
	},
	mounted: function(){
		var self = this;
		self.current.school_code = self.$store.state.user.school_code;
		self.current.username = self.$store.state.user.username;
    	self.current.uid = self.$store.state.user.uid;
		self.current.user_level = self.$store.state.user.user_level;
    	self.current.auth_token = self.$store.state.user.auth_token;
		apiDDSGeneral.getSystemAnnouncement()
		.then((response) => {
			if(response.status=="fail"){}
			else if(response.status=="success"){
				self.system_announcements = response.system_announcements;
			}
		});		
		/*apiDDSGeneral.getSchoolAnnouncement(self.current.school_id)
		.then((response) => {
			if(response.status=="fail"){}
			else if(response.status=="success"){
				self.school_announcements = response.school_announcements;
			}
		});
		*/
	},
	methods:{
	}
}
</script>
